import React from "react";
import { Checkbox, Stack, Typography } from "@mui/material";
import { frequencyDays } from "src/interfaces/IProgram";
import {
  BORDER_COLOR_CARD,
  DM_COLOR_ACCENT,
  MESSAGING_SUCCESS,
} from "src/styles";
import { useAlenSchedulingContext } from "../AlenSchedulingContext";

export function FrequencyLabel({
  selected,
  label,
  onClick,
}: {
  selected: boolean;
  label: string;
  onClick?: () => void;
}) {
  return (
    <Typography
      onClick={onClick}
      sx={[
        {
          width: "2rem",
          height: "2rem",
          lineHeight: "2rem",
          textAlign: "center",
          borderRadius: "1rem",
          border: 1,
          borderColor: BORDER_COLOR_CARD,
          backgroundColor: DM_COLOR_ACCENT,
        },
        selected
          ? { backgroundColor: MESSAGING_SUCCESS, color: "white" }
          : { backgroundColor: "white" },
        onClick ? { cursor: "pointer" } : {},
      ]}
    >
      {label}
    </Typography>
  );
}

function FrequencySelector() {
  const { newScheduling, setNewScheduling } = useAlenSchedulingContext();
  const isEverydaySelected = newScheduling.frequency.days.length === 7;

  return (
    <Stack direction="column" gap="1rem" alignItems="flex-start">
      <Stack direction="row" gap=".25rem" alignItems="center">
        {frequencyDays.map(({ label, value }) => (
          <FrequencyLabel
            key={value}
            onClick={() => {
              setNewScheduling((prev) => ({
                ...prev,
                frequency: {
                  repeat: prev.frequency.days.length === 7 ? "DAILY" : "CUSTOM",
                  days: prev.frequency.days.includes(value)
                    ? prev.frequency.days.filter((d) => d !== value)
                    : [...prev.frequency.days, value],
                },
              }));
            }}
            selected={newScheduling.frequency.days.includes(value)}
            label={label}
          />
        ))}
        <Stack direction="row" gap=".25rem" alignItems="center">
          <Checkbox
            checked={
              isEverydaySelected === undefined ? false : isEverydaySelected
            }
            onClick={() => {
              setNewScheduling((prev) => ({
                ...prev,
                frequency: {
                  repeat: isEverydaySelected ? "CUSTOM" : "DAILY",
                  days: isEverydaySelected
                    ? []
                    : frequencyDays.map(({ value }) => value),
                },
              }));
            }}
          />
          <Typography>All</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default FrequencySelector;
